module.exports = {
  footerText: `Copyright Vip-Ott.org © 2018 - ${new Date().getFullYear()}`,
  internalServerError: 'Internal server error',
  accessForbidden: 'Доступ запрещен',
}
